import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CompanyFavicon as SchemaCompanyFavicon } from '../schemas/CompanyFavicon';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Company
 */
export const GetCompanyFaviconContentType = '' as const;
export type GetCompanyFaviconRequest = void;
export type GetCompanyFaviconResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful get company favicon
     */
    '200': {
        'application/json': SchemaCompanyFavicon;
    };
};
export type GetCompanyFaviconResponseSuccess = GetCompanyFaviconResponses['200']['application/json'];
export type GetCompanyFaviconSearchParams = undefined;
export type GetCompanyFaviconPathParameters = undefined;
export const GetCompanyFaviconUrl = '/company/favicon' as const;
export const GetCompanyFaviconMethod = 'GET' as const;
export const getGetCompanyFaviconUrl = (_params?: GetCompanyFaviconPathParameters) => GetCompanyFaviconUrl;
